"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var Rating_1 = __importDefault(require("@material-ui/lab/Rating"));
var icons_1 = require("../../../../common/icons");
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var activityService_1 = require("../../../../app/services/activityService");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var store_1 = require("../../../../app/store");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b;
    return (0, core_1.createStyles)({
        editActivityModal: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        content: (_a = {
                margin: theme.spacing(1),
                backgroundColor: theme.palette.background.default,
                borderRadius: theme.youwell.shapes.borderRadiusRounder,
                padding: theme.spacing(5)
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(3),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2),
            },
            _a),
        header: (_b = {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: theme.spacing(4)
            },
            _b[theme.breakpoints.down('sm')] = {
                marginBottom: theme.spacing(3),
            },
            _b),
        editActivityModalTitle: {
            borderLeft: theme.youwell.borders.secondary,
            padding: theme.spacing(1, 2),
        },
        cancelIcon: {},
        item: {
            marginBottom: theme.spacing(3),
        },
        itemTop: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        itemContent: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: theme.palette.common.white,
            paddingLeft: theme.spacing(1),
        },
        activityText: {
            flex: '1 1 auto',
        },
        actions: {
            marginTop: theme.spacing(6),
            display: 'flex',
            justifyContent: 'center',
        },
    });
}, { name: 'DateDetails' });
var DateDetails = function (_a) {
    var open = _a.open, onClose = _a.onClose, date = _a.date, onAddClick = _a.onAddClick, onEditClick = _a.onEditClick;
    var classes = useStyles();
    var dispatch = (0, react_redux_1.useDispatch)();
    var translate = (0, translate_1.default)();
    var allActivities = (0, store_1.useYouwellSelector)(function (state) { return state.activityDataStore.activities; });
    if (!date) {
        return null;
    }
    var activitiesOnSelectedDate = allActivities === null || allActivities === void 0 ? void 0 : allActivities.filter(function (a) { return (0, dateUtils_1.isSameDate)(a.date, date); });
    var addNew = function () {
        onAddClick(date);
    };
    var editActivity = function (activity) { return function () {
        onEditClick(activity);
    }; };
    var deleteActivity = function (activity) { return function () {
        (0, activityService_1.deleteActivityData)(dispatch, activity, { callback: onClose });
    }; };
    return (React.createElement(core_1.Modal, { open: open, onClose: onClose, className: classes.editActivityModal },
        React.createElement("div", { className: classes.content },
            React.createElement("div", { className: classes.header },
                React.createElement(core_1.Typography, { className: classes.editActivityModalTitle, variant: "subtitle2" }, "".concat(translate('activityDiary.plannedActivities'), " | ").concat((0, dateUtils_1.datestamp)(date))),
                React.createElement(core_1.IconButton, { onClick: onClose },
                    React.createElement(icons_1.CancelOutlinedIcon, { className: classes.cancelIcon }))),
            React.createElement("div", null, activitiesOnSelectedDate && activitiesOnSelectedDate.map(function (activity) { return (React.createElement("div", { key: activity.id, className: classes.item },
                React.createElement("div", { className: classes.itemTop },
                    activity.category && (React.createElement(core_1.Typography, { variant: "body2" }, translate("activityDiary.categories.".concat(activity.category)))),
                    React.createElement(core_1.Typography, { variant: "body2" }, (0, dateUtils_1.hourCount)(activity.durationInMinutes, translate))),
                React.createElement("div", { className: classes.itemContent },
                    React.createElement("div", { className: classes.activityText },
                        React.createElement(core_1.Typography, null, activity.activity),
                        activity.effortRating && activity.effortRating > 0 ? (React.createElement(Rating_1.default, { size: "small", name: "effortRating-".concat(activity.id), value: activity.effortRating, color: "primary" })) : activity.effortRating === -1 ? (React.createElement(core_1.Typography, { variant: "caption" }, translate('activityDiary.notCompleted'))) : (React.createElement(core_1.Typography, { variant: "caption" }, translate('activityDiary.effortNotRegistered')))),
                    React.createElement(core_1.IconButton, { onClick: deleteActivity(activity) },
                        React.createElement(icons_1.DeleteIcon, null)),
                    React.createElement(core_1.IconButton, { onClick: editActivity(activity) },
                        React.createElement(icons_1.EditIcon, null))))); })),
            React.createElement("div", { className: classes.actions },
                React.createElement(core_1.Button, { onClick: addNew, color: "primary" }, translate('activityDiary.addNewActivity'))))));
};
DateDetails.defaultProps = {
    date: null,
};
exports.default = DateDetails;
